import React, { FC, useEffect, useState } from 'react'
import styles from 'styles/components/template.module.scss'
import { Spacer } from 'components/Utility'
import { RedLogo } from 'components/Image'
import { Description } from 'components/Typography'
import { useDispatch, useSelector } from 'react-redux'
import { push } from 'connected-react-router'
import { State } from 'index'
import { acceptUpdateInvitation } from 'reducks/staff/operations'

// 紐付けの結果に応じて、完了画面かエラー画面に遷移する
const RegisterUpdateTemplate: FC = () => {
  const dispatch = useDispatch()
  const queryToken = useSelector((state: State) => state.router.location.query.token)
  // 開いたときの招待トークンを使う。紐付け後に完了画面へ遷移すると query から token がなくなるため、
  // query の変化に合わせて読み直すと、完了画面へ遷移する途中でエラー画面に遷移してしまう
  const [token] = useState<string | undefined>(queryToken)

  useEffect(() => {
    ;(async () => {
      // 招待トークンのないリンク（旧形式のリンクを含む）は使えない
      if (!token) {
        dispatch(push('/register/error'))
        return
      }
      await dispatch(acceptUpdateInvitation(token))
    })()
  }, [token])

  return (
    <div className={styles.standard}>
      <Spacer size={40} />
      <RedLogo />
      <Spacer size={24} />
      <Description align={'center'} description={'アカウントの紐付けを行っています。'} />
    </div>
  )
}

export default RegisterUpdateTemplate
